const bodyElement = document.querySelector("body");
const navbarMenu = document.querySelector("#cs-navigation");

const is_dark_mode = function () {
    return bodyElement.classList.contains("dark-mode");
};

export function reveal_nav() {
    if (!navbarMenu) return;
    const y = window.scrollY;
    const invisible_threshold = bodyElement.clientWidth * 0;
    const visible_threshold = bodyElement.clientWidth * 0.3;
    const new_opacity =
        y <= invisible_threshold
            ? 0
            : y >= visible_threshold
              ? 1
              : Math.pow(
                    (1 * (y - invisible_threshold)) /
                        (visible_threshold - invisible_threshold),
                    2,
                );
    if (is_dark_mode()) {
        navbarMenu.style.backgroundColor = `rgba(37, 37, 33, ${new_opacity})`;
    } else {
        navbarMenu.style.backgroundColor = `rgba(255, 255, 255, ${new_opacity})`;
    }

    navbarMenu.classList[new_opacity > 0 ? "add" : "remove"]("visible");
}

window.addEventListener("resize", reveal_nav);
window.addEventListener("scroll", reveal_nav);
